const BursarInitialValues = {
  bursarComment: '',
  isBursarReturnMade: false,
};

export type BursarFormBody = typeof BursarInitialValues;

export default BursarInitialValues;
